<template>
  <vue-form @submit="submit"
           :disabled="isFormDisabled && !canUpdateStock"
           :form="form"
           :action="action"
           :status="status">
    <section class="form-section">
      <header>
        <h3>Produit</h3>
        <p>
            Le nom est obligatoire et sera utilisé à travers l'application pour identifier le produit.
            Pensez à choisir un nom pertinent, il sera ainsi plus facile de retrouver le produit dans la recherche.
        </p>
      </header>
      <div>
        <form-group class="md:w-1/2" field="name" label="Nom">
          <vue-input placeholder="ex: Baguette"
                     id="name"
                     :disabled="isFormDisabled"
                     v-model="form.name"/>
        </form-group>

        <form-group class="md:w-1/2" field="family" label="Famille">
          <select-family :config="{allowEmpty: true, disabled: isFormDisabled}" v-model="form.family"/>
        </form-group>

        <form-group field="description" label="Description">
          <vue-textarea id="description"
                        v-model="form.description"
                        :disabled="isFormDisabled"
                        placeholder="ex: Farine de blé, eau, levure"/>
        </form-group>
      </div>
    </section>
    <section class="form-section">
      <header>
        <h3>Stock</h3>
        <p>
            Le stock sera réduit automatiquement après chaque commande.
            Un produit qui n'est plus en stock ne peut plus être commandé.
        </p>
      </header>
      <div>
        <form-group class="md:w-1/2" field="stock" label="Quantité de produit en stock">
          <vue-input-number :min="0" id="stock" v-model="form.stock" :disabled="isStockFieldDisabled"/>
          <small>Laissez le champ vide si vous ne souhaitez pas gérer le stock.</small>
        </form-group>
      </div>
    </section>
    <section class="form-section">
      <header>
        <h3>Statut</h3>
        <p>
            Un produit inactif n'apparait plus dans l'application et ne peut plus être commandé.
        </p>
      </header>
      <div>
        <form-group field="active" label="Quel est le statut du produit ?">
          <p class="-m-1">
            <vue-radio class="m-1" :label="true" v-model="form.active" :disabled="isFormDisabled">Actif</vue-radio>
            <vue-radio class="m-1" :label="false" v-model="form.active" :disabled="isFormDisabled">Inactif</vue-radio>
          </p>
        </form-group>
      </div>
    </section>
    <section class="form-section">
      <header>
        <h3>Conditionnement</h3>
        <p>
            Le conditionnement permet de générer correctement les étiquettes.
            Un produit emballé seul aura sa propre étiquette et autant d'étiquettes que de quantité.
        </p>
      </header>
      <div>
        <form-group field="pack_alone" label="Comment le produit doit-il être conditionné ?">
          <p class="-m-1">
            <vue-radio class="m-1" :label="false" v-model="form.pack_alone" :disabled="isFormDisabled">Emballé à plusieurs</vue-radio>
            <vue-radio class="m-1" :label="true" v-model="form.pack_alone" :disabled="isFormDisabled">Emballé seul</vue-radio>
          </p>
        </form-group>
      </div>
    </section>
    <section class="form-section" v-if="isUpdateForm && canDelete">
      <header>
        <h3>Zone de danger</h3>
        <p>
          Le produit sera <strong>définitivement supprimé</strong> et ne pourra pas être restauré.
        </p>
      </header>
      <div>
        <form-group label="Voulez-vous supprimer définitivement ce produit ?">
          <confirm-button @confirmed="destroy"
                          popover-type="popover-top-left sm:popover-right"
                          btn-class="btn-primary btn-outline"
                          btn-confirm-text="Supprimer"
                          :disabled="isFormDisabled"
                          :status="statusDestroy">Supprimer le produit</confirm-button>
        </form-group>
      </div>
    </section>
  </vue-form>
</template>

<script>
import Form from 'form-backend-validation';
import SelectFamily from '../families/FamilySelect.vue';
import form from '../../mixins/form';

export default {
  /* globals route */
  mixins: [form],

  components: { SelectFamily },

  created() {
    if (this.isUpdateForm) {
      this.$authorization.register(`products-updateStock-${this.model.id}`);
    }
  },

  computed: {
    canUpdateStock() {
      if (!this.isUpdateForm) {
        return false;
      }
      return this.$can(`products-updateStock-${this.model.id}`);
    },

    isStockFieldDisabled() {
      return (
        this.form.processing ||
        (this.isUpdateForm && !this.canUpdate && !this.canUpdateStock)
      );
    },

    routeUpdateUrl() {
      if (!this.isUpdateForm) {
        return null;
      }
      return !this.canUpdate && this.canUpdateStock
        ? route(`api.${this.resource}.stock.update`, this.model.id)
        : route(`api.${this.resource}.update`, this.model.id);
    },
  },

  data() {
    return {
      form: new Form({
        name: '',
        description: '',
        family: '',
        stock: null,
        active: true,
        pack_alone: false,
      }),
    };
  },
};
</script>